/* Filters, count pills and the topic chip.
   Filter order is fixed and deliberate: search, bucket, stage, journey, confidence,
   AI page, SEO action. Dropdowns only ever offer values present in the run. */

import { $, esc, fmt, scase } from "../util.js";
import { BUCKETS } from "../colors.js";

export function renderFilterOptions(facets) {
  const opt = (v, label, selected) => '<option value="' + esc(v) + '"' + (selected ? " selected" : "") + ">" + esc(label) + "</option>";

  $("f-bucket").innerHTML = '<option value="all">Bucket</option>' +
    facets.buckets.map(b => opt(b.value, scase(b.value))).join("");
  $("f-stage").innerHTML = '<option value="all">Stage</option>' +
    facets.stages.map(s => opt(s.value, scase(s.value))).join("");
  $("f-journey").innerHTML = '<option value="all">Journey</option>' +
    facets.journeys.map(j => opt(j.value, scase(j.value))).join("");
  $("f-conf").innerHTML = '<option value="0">Confidence</option>' +
    facets.confidence.map(c => opt(c.value, c.label)).join("");
  $("f-ai").innerHTML = '<option value="all">AI page</option>' +
    opt("1", "On AI pages") + opt("0", "Not on AI pages");
  $("f-action").innerHTML = '<option value="all">SEO action</option>' +
    facets.actions.map(a => opt(a.value, a.label)).join("");
}

/* Keeps every dropdown showing what the filter state actually is, so a click on a chart
   can never leave the controls disagreeing with the table. */
export function syncFilterControls(f) {
  $("f-bucket").value = f.bucket || "all";
  $("f-stage").value = f.stage || "all";
  $("f-journey").value = f.journey || "all";
  $("f-conf").value = f.conf || "0";
  $("f-ai").value = f.ai || "all";
  $("f-action").value = f.action || "all";
  if ($("q-search").value !== (f.search || "")) $("q-search").value = f.search || "";
}

export function renderPills(facets, f, onPick) {
  const pills = facets.buckets.map(b => {
    const m = BUCKETS[b.value] || BUCKETS.ordinary;
    const on = f.bucket === b.value ? " on" : "";
    return '<span class="cpill' + on + '" data-pb="' + b.value + '" style="color:' + m[0] + ";background:" + m[1] + '"><b>' + fmt(b.count) + "</b> " + scase(b.value) + "</span>";
  }).join("") +
  (facets.aiPages.available
    ? '<span class="cpill' + (f.ai === "1" ? " on" : "") + '" data-pai="1" style="color:#0EA5E9;background:rgba(14,165,233,.09)"><b>' + fmt(facets.aiPages.count) + "</b> on AI pages</span>"
    : "");

  $("pills").innerHTML = pills;
  $("pills").querySelectorAll("[data-pb]").forEach(el => el.addEventListener("click", () =>
    onPick({ bucket: f.bucket === el.dataset.pb ? "all" : el.dataset.pb })));
  $("pills").querySelectorAll("[data-pai]").forEach(el => el.addEventListener("click", () =>
    onPick({ ai: f.ai === "1" ? "all" : "1" })));
}

export function renderChips(f, onClear) {
  $("chips").innerHTML = f.topic ? '<span class="chip" data-c="topic">topic: ' + esc(f.topic) + " ✕</span>" : "";
  $("chips").querySelectorAll(".chip").forEach(el => el.addEventListener("click", () => onClear(el.dataset.c)));
}

/* Highlights whichever filters are doing something, and shows the reset button only when
   there is something to reset. */
export function markActiveFilters(f) {
  const mark = (id, active) => $(id)?.classList.toggle("factive", !!active);
  mark("f-bucket", f.bucket && f.bucket !== "all");
  mark("f-stage", f.stage && f.stage !== "all");
  mark("f-journey", f.journey && f.journey !== "all");
  mark("f-conf", f.conf && f.conf !== "0");
  mark("f-ai", f.ai && f.ai !== "all");
  mark("f-action", f.action && f.action !== "all");
  document.querySelector(".fsearch")?.classList.toggle("factive", !!f.search);

  const anyActive = (f.bucket && f.bucket !== "all") || (f.stage && f.stage !== "all") ||
    (f.journey && f.journey !== "all") || (f.conf && f.conf !== "0") || (f.ai && f.ai !== "all") ||
    (f.action && f.action !== "all") || !!f.topic || !!f.search;
  const reset = $("btn-freset");
  if (reset) reset.style.display = anyActive ? "" : "none";
}

export const EMPTY_FILTERS = {
  bucket: "all", stage: "all", journey: "all", action: "all",
  conf: "0", ai: "all", search: "", topic: null,
};
